import * as React from "react";
import { cx } from "utils/join-classnames";
import { Button, Icon } from "ui/components";
import styles from "./TagInput.styles.module.scss";

interface Props {
    value: string[];
    onChange(tags: string[]): void;
    id?: string;
    valid?: boolean;
    disabled?: boolean;
}

const TagInput: React.FC<Props> = ({
    value,
    onChange,
    id = "",
    valid,
    disabled,
}: Props) => {
    const [newTag, setNewTag] = React.useState<string>("");

    const removeTag = (tagIndex: number) => value.filter((_, idx) => idx !== tagIndex);

    const handleNewTag = (ev: React.ChangeEvent<HTMLInputElement>) => {
        setNewTag(ev.target.value);
    };

    const handleKeyPress = (ev: React.KeyboardEvent<HTMLInputElement>) => {
        if (ev.key === "Enter") {
            ev.preventDefault();
            const tempTag = newTag.trim();
            const tempValue = [...value];
            if (tempTag) {
                onChange(tempValue.concat(tempTag));
                setNewTag("");
            }
        }
    };

    return (
        <div
            className={cx(
                styles.container,
                styles.inputfield,
                valid && valid !== undefined && styles.textfield__invalid,
                disabled ? styles.disabled : null,
            )}
        >
            {value.map((tag, index) => (
                <span
                    className={styles.tag}
                    key={`${tag}_${Math.random() * 10000}`}
                >
                    {tag}
                    <Button
                        className={styles.tag__remove}
                        type="function"
                        theme="light"
                        onRed
                        onClick={() => onChange(removeTag(index))}
                    >
                        <Icon name="close" />
                    </Button>
                </span>
            ))}
            <input
                className={styles.input}
                value={newTag}
                onChange={handleNewTag}
                onKeyPress={handleKeyPress}
                placeholder="Enter a tag title and press ENTER"
                id={id}
            />
        </div>
    );
};
export default TagInput;
